import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';
import { getBenefitSectionDetails } from '@/domains/claims/features/ClaimSetClaimList/store/claimSetClaimList';
import { getPayments } from '@/domains/payments/features/PaymentsSection/store/payments.slice';
import HttpService from '@/services/HttpService/HttpService';
import {
  createTransactionFromBenefitAdjustment,
  createTransactionFromPaymentAdjustment,
} from '../store/createTransactionFromAdjustment.slice';

function* createTransactionFromBenefitAdjustmentSaga({
  payload: { adjustmentId, claimId },
}: PayloadAction<{ claimId: string | number; adjustmentId: string | number }>) {
  try {
    yield call(HttpService.post, `/${EdsEntityCodes.Transaction}/from-benefit-adjustment`, {
      benefitAdjustmentId: adjustmentId,
    });

    yield put(getBenefitSectionDetails(`${claimId}`));
  } catch (error) {
    console.error(error);
  }
}

function* createTransactionFromPaymentAdjustmentSaga({
  payload: { adjustmentId, claimId },
}: PayloadAction<{ claimId: string | number; adjustmentId: string | number }>) {
  try {
    yield call(HttpService.post, `/${EdsEntityCodes.Transaction}/from-payment-adjustment`, { adjustmentId });

    yield put(getPayments({ claimId: Number(claimId) }));
  } catch (error) {
    console.error(error);
  }
}

export function* createTransactionFromAdjustmentWatcher() {
  yield takeLatest([createTransactionFromPaymentAdjustment.type], createTransactionFromPaymentAdjustmentSaga);
  yield takeLatest([createTransactionFromBenefitAdjustment.type], createTransactionFromBenefitAdjustmentSaga);
}
